import React from 'react'
import { useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ResortDetailsMain from '../Components/Resort/ResortDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { api } from '../services/api'
import { usePageBanner } from '../hooks/usePageBanner'

function ResortDetails() {
    const { id } = useParams()
    const { title, bgImage } = usePageBanner({
        itemLoader: api.getResort,
        itemId: id,
        fallbackTitle: 'Resort Details',
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <ResortDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default ResortDetails
